const langJA = {
  dv1: "デモ動画 1",
  dv2: "デモ動画 2",
  sjkViews: "19k人の閲覧者",
  ltqian: "2日前",
  ssekViews: "32k人の閲覧者",
  ytqian: "1日前",
  editPattern: "動画のパターンを編集",
  createPattern: "動画のパターンを作成",
  SyncToy: "Lovenseのおもちゃと動画を接続",
  connectRemote: "Lovense Remoteに接続",
  "Connect to Remote": "Lovense Remoteに接続",
  "Connected to Remote": "Lovense Remoteに接続されました",
  connecting: "接続中",
  "Connecting...": "接続中",
  connectFail: "接続失敗",
  "Connection failed": "接続失敗",
  patternEditor: "パターンエディター",
  "Pattern Editor": "パターンエディター",
  "Edit Pattern": "パターンを編集",
  editMode: "パターンの修正",
  "Edit Mode": "パターンの修正",
  back: "戻る",
  submit: "提出",
  Submit: "提出",
  exit: "退出",
  Exit: "退出",
  submitSure: "パターンを提出しますか？",
  submitExit: "提出して退出",
  cancel: "キャンセル",
  Cancel: "キャンセル",
  yes: "はい",
  Yes: "はい",
  preview: "プレビュー",
  Preview: "プレビュー",
  vibration: "振動",
  previewTip1: "Lovense Remoteにおもちゃを接続してパターンを確認",
  previewTip2: "1.Lovense Remote アプリ(iOS/Android)をダウンロード",
  previewTip3: "(App StoreもしくはGoogle Playにて)",
  previewTip4: "2.LovenseおもちゃをLovense Remoteに接続",
  previewTip5: "(おもちゃの電源を入れて、アプリを開き、右角にある接続アイコンをクリックしてください。)",
  previewTip6: "3.Lovense RemoteでQRコードをスキャンする",
  previewTip7: "(右角にある\"+\"をタップして\"QRでスキャンをクリック\")",
  syncing: "Lovenseのおもちゃを動画と接続",
  unsync: "切断",
  retry: "リトライ",
  end: "終了",
  reconnecting: "再接続中",
  unsupport: "Lovenseのおもちゃは使用できません。",
  disconnect: "おもちゃとの接続が切断されました。",
  syncAgain: "再度同期する",
  disconnectApp: "Lovense Remoteとの接続が切断されました",
  clickPreview: "\"Lovense Remoteに接続\"をクリックしておもちゃを接続しLovense Remoteアプリで再生してください。",
  lsUnsupport: "Lovenseのおもちゃが現在サポートされていません。",
  "one toy synced": "が動画に同期されました。",
  "two toys synced": "が動画に同期されました。",
  "The toys are synced to video": "おもちゃがビデオに同期されました。",
  OK: "OK",
  "Please create a pattern first!": "パターンを最初に作成してください。",
  "Pattern data can not be empty!": "パターンのデータは空にできません。",
  "Pattern submitted successfully!": "パターンは無事提出されました。",
  "Failed to submit pattern, please try again!": "パターンの提出に失敗しました。再度試してください。",
  "Submit and Exit": "提出して退出",
  "Do you want to submit your pattern?": "パターンを提出しますか？",
  notHaveToy: "Lovenseのおもちゃを所持していないですか？",
  clickHere: "こちらをクリック",
  findOne: "してあなたに合うおもちゃを見つけよう！",
  "QR Code": "QRコード",
  "and": "と",
};
export default langJA;